import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, iconBg }) => {
  const isPositive = changeType === 'positive';
  
  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 hover:border-blue-200">
      <div className="flex items-start justify-between mb-4">
        <div className={`w-12 h-12 rounded-xl ${iconBg} flex items-center justify-center shadow-sm`}>
          <Icon name={icon} size={24} color="#FFFFFF" />
        </div>
        <div className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-semibold ${
          isPositive ? 'bg-emerald-50 text-emerald-700 border border-emerald-200' : 'bg-red-50 text-red-700 border border-red-200'
        }`}>
          <Icon name={isPositive ? 'TrendingUp' : 'TrendingDown'} size={14} />
          <span>{change}</span>
        </div>
      </div>
      <div className="space-y-1">
        <p className="text-sm text-gray-600 font-medium">{title}</p>
        <p className="text-3xl font-bold text-gray-900 tracking-tight">{value}</p>
      </div>
    </div>
  );
};

export default MetricCard;